import { render, staticRenderFns } from "./newSubjectTestPerformance.vue?vue&type=template&id=a670da04&scoped=true"
import script from "./newSubjectTestPerformance.vue?vue&type=script&lang=js"
export * from "./newSubjectTestPerformance.vue?vue&type=script&lang=js"
import style0 from "./newSubjectTestPerformance.vue?vue&type=style&index=0&id=a670da04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a670da04",
  null
  
)

export default component.exports